/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
}); 

jQuery(document).ready(function() {

	jQuery('.partnerslider').slick({
			speed: 1000,
			arrows:	false,
			autoplay: true,
			autoplaySpeed: 3000,
			centerMode: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [
				{ breakpoint : 1700, settings : { slidesToShow : 5 } },
				{ breakpoint : 1280, settings : { slidesToShow : 3 } },
				{ breakpoint : 1024, settings : { slidesToShow : 2 } },
				{ breakpoint : 550, settings : { slidesToShow : 1 } }
			]
		});

	// Slider : Même hauteur pour toutes les slides
		jQuery('.slick-equalizer').on('setPosition', function () {
			jQuery(this).find('.slick-content').height('auto');
			var slickTrack = jQuery(this).find('.slick-track');
			var slickTrackHeight = jQuery(slickTrack).height();
			jQuery(this).find('.slick-content').css('height', slickTrackHeight + 'px');
		});

}); // END (document).ready
